import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { hasAppointment } from "src/utils/scheduleAppointment";
import StepThree from "./StepThree";

function mapStateToProps({ currentDeal }: ApplicationStore) {
    const { appointment } = currentDeal;

    return {
        hasAppointment: hasAppointment(appointment),
    };
}

export default connect(mapStateToProps)(StepThree);
